<script lang="ts" setup>
  import {
    definePropsEntry,
    defineEmitsEntry,
  } from "frontend/utils/base-calendar-utils";
  import { CalendarEntryUnitAbsence } from "frontend/interfaces/calendar";

  defineProps(definePropsEntry<CalendarEntryUnitAbsence>());
  defineEmits(defineEmitsEntry());
</script>

<template>
  <div class="unit-absence">
    <div class="unit-absence__type-label"><strong>Abwesenheit</strong></div>
    <div v-if="entry && entry.label">{{ entry.label }}</div>
  </div>
</template>

<style lang="scss" scoped>
  @use "shared/styles/colors";
  @use "frontend/styles/features";

  .unit-absence {
    // STRIPES
    $_stripes-width: 6px;
    background: repeating-linear-gradient(
      -45deg,
      colors.$color_calendar__unit__diagonal-stripes--c2,
      colors.$color_calendar__unit__diagonal-stripes--c2 #{$_stripes-width},
      colors.$color_calendar__unit__diagonal-stripes--c1 #{$_stripes-width},
      colors.$color_calendar__unit__diagonal-stripes--c1 #{2 * $_stripes-width}
    );

    padding: 5px;
  }

  .unit-absence__type-label {
    text-align: center;
  }
</style>
